// utils/formEventFormatters/index.js

import formatClearModel from './formatClearModel'
import formatFilter from './formatFilter'
import formatLock from './formatLock'
import formatPermalink from './formatPermalink'
import formatPermalinkPrefix from './formatPermalinkPrefix'
import formatPrependSchema from './formatPrependSchema'
import formatPreview from './formatPreview'
import formatRemoveValue from './formatRemoveValue'
import formatResetItems from './formatResetItems'
import formatSet from './formatSet'
import formatToggleInput from './formatToggleInput'

export default {
  formatClearModel,
  formatFilter,
  formatLock,
  formatPermalink,
  formatPermalinkPrefix,
  formatPrependSchema,
  formatPreview,
  formatRemoveValue,
  formatResetItems,
  formatSet,
  formatToggleInput,
}
